module.exports = __webpack_public_path__ + "6d3a84b6fc825bf3b9dc258af06cebe3.svg";